<script setup lang="ts">
import { useAuthStore } from '@afinius/hooks/store/useAuthStore';
import Button from '@afinius/ui-framework/Button/Button.vue';
import Cluster from '@afinius/ui-framework/Cluster/Cluster.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const authStore = useAuthStore();
const isImpersonated = computed(() => authStore.impersonated);

const stopImpersonate = () => {
  authStore.stopImpersonate();
};
</script>

<template>
  <Cluster v-if="isImpersonated" class="impersonate-warning" alignItems="center">
    <span>
      <strong>
        {{ t('please-note') }}
      </strong>

      {{ t('impersonate-warning') }}
    </span>

    <Button appearance="light" color="secondary" size="sm" :onClick="stopImpersonate">
      {{ t('stop') }}
    </Button>
  </Cluster>
</template>

<style lang="scss" scoped>
@use './ImpersonateWarning.scss';
</style>
